<template>
  <a
    href="#"
    class="nav-link py-0 text-muted"
    @click.prevent="toggleStar"
  >
    <i
      :class="{
        'far': !isStarred,
        'fas text-warning': isStarred,
        'fa-star': true,
      }"
    ></i>
  </a>
</template>

<script>
export default {
  props: ['lectureId'],
  data() {
    return {
      isStarred: true,
    }
  },
  mounted() {
  },
  methods: {
    toggleStar() {
      axios.post(`/lecture/${this.lectureId}/star`)
      .then(() => {
        this.isStarred = !this.isStarred
      })
    },
  },
}
</script>
